import axios from "axios";

// Server URL
//  const axiosBaseUrl = axios.create({baseURL: "http://109.106.244.229/api/v1"});
// const axiosBaseUrl = axios.create({baseURL: "http://auctionegypt.com/api/v1"});

//  const axiosBaseUrl = axios.create({baseURL: "http://localhost:9000/api/v1"});
 const axiosBaseUrl = axios.create({baseURL: "https://app.auctionegypt.com/api/v1"});

//  const axiosBaseUrl = axios.create({baseURL: "https://tough-ox-hospital-gown.cyclic.app"});

// const axiosBaseUrl = axios.create({baseURL: "https://e-commerce-9kwf.onrender.com/api"});


export default axiosBaseUrl;
